import type { GroupContent } from "@prismicio/types-internal/lib/content"
import type { Group } from "@prismicio/types-internal/lib/customtypes"

import { FieldInGroupContextProvider } from "./FieldContext"
import { RepeatableZoneEditor } from "./zones/RepeatableZoneEditor"

interface GroupEditorProps {
  content: GroupContent | undefined
  group: Group
  id: string
  readOnly: boolean
  onContentChange: (content: GroupContent) => void
}

export function GroupEditor(props: GroupEditorProps) {
  const { group, content, onContentChange, ...otherProps } = props

  return (
    <FieldInGroupContextProvider>
      <RepeatableZoneEditor
        {...otherProps}
        title={getGroupLabel(group)}
        addItemButtonTitle={`Add item in "${getGroupLabel(group)}"`}
        repeatable={group.config?.repeat !== false}
        repeatableZone={group.config?.fields ?? {}}
        content={content?.value}
        onContentChange={(repeatableZoneContent) => {
          onContentChange({
            __TYPE__: "GroupContentType",
            value: repeatableZoneContent,
          })
        }}
      />
    </FieldInGroupContextProvider>
  )
}

export function getGroupLabel(group: Group): string {
  return group.config?.label ?? group.fieldset ?? group.type
}
